import React from 'react';
import { useChats, useProjects } from '../../shared/api/data';
import type { ProjectLifecycle } from '../../shared/fixtures/types';
import '../../app/App.css';

const LIFECYCLE_COLOR: Record<ProjectLifecycle, string> = {
  active: 'var(--green)',
  draft: 'var(--amber)',
  paused: 'var(--t-faint)',
  archived: 'var(--t-faint2)',
};

interface LeftNavProps {
  selectedProjectId: string | null;
  selectedChatId: string | null;
  onSelectProject: (id: string) => void;
  onSelectChat: (id: string, projectId: string) => void;
}

/** Left nav (C-projects/chat). Projects → GET /projects, chats → GET /cockpit-chat/history. */
export function LeftNav({
  selectedProjectId,
  selectedChatId,
  onSelectProject,
  onSelectChat,
}: LeftNavProps): React.ReactElement {
  const projects = useProjects();
  const chats = useChats();

  return (
    <nav className="nav" aria-label="Projects and chats">
      <section className="navSection">
        <h2 className="navHead">Projects</h2>
        {projects.isLoading && <div className="navRowSub" style={{ padding: '4px 8px' }}>Loading…</div>}
        {projects.data?.data.map((p) => (
          <button
            key={p.id}
            type="button"
            className="navRow"
            data-active={p.id === selectedProjectId}
            aria-pressed={p.id === selectedProjectId}
            onClick={() => onSelectProject(p.id)}
          >
            <span className="lifecycleDot" style={{ background: LIFECYCLE_COLOR[p.lifecycle] }} aria-hidden />
            <span className="navRowMain">
              <span className="navRowTitle">{p.name}</span>
              <span className="navRowSub">{p.goal}</span>
            </span>
            <span className="navRowMeta">{p.eventCount}</span>
          </button>
        ))}
      </section>

      <section className="navSection">
        <h2 className="navHead">Chats</h2>
        {chats.isLoading && <div className="navRowSub" style={{ padding: '4px 8px' }}>Loading…</div>}
        {chats.data?.data.map((c) => (
          <button
            key={c.id}
            type="button"
            className="navRow"
            data-active={c.id === selectedChatId}
            aria-pressed={c.id === selectedChatId}
            onClick={() => onSelectChat(c.id, c.project)}
          >
            <span className="navRowMain">
              <span className="navRowTitle">
                {c.pinned ? '★ ' : ''}
                {c.name}
              </span>
              <span className="navRowSub">{c.last}</span>
            </span>
          </button>
        ))}
      </section>
    </nav>
  );
}
